(function () {
  var legacyProductName = /Keto\s+BHB\s+Plus\s+Patch/gi;
  var restrictedReviewText = /5-HTP|beta-hydroxybutyrate|\bBHB\b|GLP-1|Ozempic|Wegovy|Mounjaro|Zepbound/i;
  var reviewCardSelector = '.junip-review-grid-item-container, .junip-review-list-item-container';
  var scheduled = false;

  function sanitizeJunipReviews() {
    document.querySelectorAll('.junip-review-product a').forEach(function (link) {
      if (legacyProductName.test(link.textContent)) {
        link.textContent = link.textContent.replace(legacyProductName, 'Keto Plus Patch');
        link.href = '/products/keto-plus-patch';
      }
      legacyProductName.lastIndex = 0;
    });

    document.querySelectorAll(reviewCardSelector).forEach(function (card) {
      if (restrictedReviewText.test(card.textContent)) {
        card.remove();
      }
    });
  }

  function scheduleSanitize() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      sanitizeJunipReviews();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSanitize, { once: true });
  } else {
    scheduleSanitize();
  }

  new MutationObserver(scheduleSanitize).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
